import Vue from 'vue'
import Router from 'vue-router'
import PSMHome from '@/components/PSM-Home'
import Login from '@/components/Login2'
import Register from '@/components/Register'
import Reset from '@/components/Reset'
import SeasonSettings from '@/components/Season-Settings'
import SeasonGames from '@/components/Season-Games'
import SeasonStats from '@/components/Season-Stats'
import SeasonPlayers from '@/components/Season-Players'
import SeasonSchedules from '@/components/Season-Schedules'
import GameBlinds from '@/components/Game-Blinds'
import GameEvents from '@/components/Game-Events'
import GameTimer from '@/components/Game-Timer'
import GameBroadcastRaw from '@/components/Game-Broadcast-Raw'
import firebase from 'firebase/app'
import { store } from '../store'

Vue.use(Router)

const checkSeasonsLoaded = (to, from, next) => {
  function proceed () {
    if (!store.state.loading.seasons) {
      next()
    }
  }
  if (store.state.loading.seasons) {
    store.watch(
      (state) => state.loading.seasons,
      (value) => {
        if (value === false) {
          proceed()
        }
      }
    )
  } else {
    proceed()
  }
}

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/Home'
    },
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Game/blinds',
      name: 'GameBlinds',
      beforeEnter: checkSeasonsLoaded,
      component: GameBlinds,
      meta: {
        requiresAuth: true,
        title: '$game$ > Blinds'
      }
    },
    {
      path: '/Game/events',
      name: 'GameEvents',
      beforeEnter: checkSeasonsLoaded,
      component: GameEvents,
      meta: {
        requiresAuth: true,
        title: '$game$ > Events'
      }
    },
    {
      path: '/Game/timer',
      name: 'GameTimer',
      beforeEnter: checkSeasonsLoaded,
      component: GameTimer,
      meta: {
        requiresAuth: true,
        title: '$game$ > Timer'
      }
    },
    {
      path: '/Season/settings',
      name: 'SeasonSettings',
      beforeEnter: checkSeasonsLoaded,
      component: SeasonSettings,
      meta: {
        requiresAuth: true,
        title: '$season$ > Settings'
      }
    },
    {
      path: '/Home',
      name: 'PSMHome',
      component: PSMHome,
      meta: {
        requiresAuth: true,
        title: 'Home'
      }
    },
    {
      path: '/Season/stats',
      name: 'SeasonStats',
      beforeEnter: checkSeasonsLoaded,
      component: SeasonStats,
      meta: {
        requiresAuth: true,
        title: '$season$ > Stats'
      }
    },
    {
      path: '/Season/players',
      name: 'SeasonPlayers',
      beforeEnter: checkSeasonsLoaded,
      component: SeasonPlayers,
      meta: {
        requiresAuth: true,
        title: '$season$ > Players'
      }
    },
    {
      path: '/Season/schedules',
      name: 'SeasonSchedules',
      beforeEnter: checkSeasonsLoaded,
      component: SeasonSchedules,
      meta: {
        requiresAuth: true,
        title: '$season$ > Schedules'
      }
    },
    {
      path: '/Season/games',
      name: 'SeasonGames',
      beforeEnter: checkSeasonsLoaded,
      component: SeasonGames,
      meta: {
        requiresAuth: true,
        title: '$season$ > Games'
      }
    },
    {
      path: '/GameBroadcastRaw',
      name: 'GameBroadcastRaw',
      component: GameBroadcastRaw,
      meta: {
        requiresAuth: false,
        nofluff: true
      }
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) next('Login')
  else if (requiresAuth && currentUser) {
    document.title = `Poker Season Manager`
    next()
  } else {
    document.title = `Poker Season Manager`
    next()
  }
})
